module.exports = __webpack_public_path__ + "static/media/small-placeholder.046129cd.svg";